import { render } from "./QuickReg.vue?vue&type=template&id=19231004"
import script from "./QuickReg.vue?vue&type=script&lang=js"
export * from "./QuickReg.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__